import React from 'react';
import { useAuthStore } from '../../store/auth';
import Carousel from './HomePageCarousel';
import OffersCarousel from './OffersCarousel';
import Banner_03 from './Banners/banner-03';
import MostViewedCarousel from './MostViewedCarousel';
import Categories from './Categories'; 
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import CuratedProductsShowcase from './CuratedProductsShowcase';
import ImageMarquee from '../../components/ImageMarquee';

const Home = () => {
  const [isLoggedIn, user] = useAuthStore((state) => [
    state.isLoggedIn,
    state.user,
  ]);

  return (
    <div className="home-page">
      {isLoggedIn() ? <LoggedInView user={user()} /> : <LoggedOutView />}
    </div>
  );
};

const LoggedInView = ({ user }) => {
  return (
    <div>
      <HeroSection />
      <div className="home-content">
        <OffersCarousel />
        <ImageMarquee />
        <Categories />
        <MostViewedCarousel />
        <Banner_03 />
        <FeaturesSection />
        <CuratedProductsShowcase />
      </div>
    </div>
  );
};

export const LoggedOutView = ({ title = 'Home' }) => {
  return (
    <div>
      <HeroSection />
      <div className="home-content">
        <OffersCarousel />
        <ImageMarquee />
        <Categories />
        <MostViewedCarousel />
        <Banner_03 />
        <FeaturesSection />
        <CuratedProductsShowcase />
      </div>
    </div>
  );
};

export default Home;

// Modern Home Page Styles
const homeStyles = `
  .home-page {
    min-height: 100vh;
    background: #ffffff;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  
  .home-content {
    background: #fafafa;
    padding-bottom: 40px;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = homeStyles;
  document.head.appendChild(styleSheet);
}